import { Button, Cross1Icon, MagnifyingGlassIcon, TextField } from '@protoss/ui';
import * as React from 'react';

interface SalesHeaderSearchProps {
  value: string;
  onChange: (next: string) => void;
  placeholder?: string;
  ariaLabel?: string;
}

export function SalesHeaderSearch({
  value,
  onChange,
  placeholder = 'Search…',
  ariaLabel = 'Search',
}: SalesHeaderSearchProps) {
  const [open, setOpen] = React.useState(false);
  const rootRef = React.useRef<HTMLDivElement>(null);
  const inputRef = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    if (value.trim()) {
      setOpen(true);
    }
  }, [value]);

  React.useEffect(() => {
    if (!open) return;
    const handlePointerDown = (event: MouseEvent) => {
      if (!rootRef.current) return;
      if (rootRef.current.contains(event.target as Node)) return;
      if (!value.trim()) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handlePointerDown);
    return () => {
      document.removeEventListener('mousedown', handlePointerDown);
    };
  }, [open, value]);

  return (
    <div ref={rootRef} className={`sales-header-search${open ? ' sales-header-search--open' : ''}`}>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="sales-header-search__toggle"
        onClick={() => {
          setOpen(true);
          window.setTimeout(() => inputRef.current?.focus(), 0);
        }}
        aria-label={ariaLabel}
      >
        <MagnifyingGlassIcon width={14} height={14} aria-hidden="true" />
      </Button>

      <div className="sales-header-search__input-wrap">
        <span className="sales-header-search__leading" aria-hidden="true">
          <MagnifyingGlassIcon width={14} height={14} />
        </span>
        <TextField
          ref={inputRef}
          className="sales-header-search__field"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          aria-label={ariaLabel}
        />
        <button
          type="button"
          className="sales-header-search__clear"
          onClick={() => onChange('')}
          aria-label="Clear search"
        >
          <Cross1Icon width={12} height={12} aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
